export class MenuItem {
  public id: string;
  public title: string;
  public groupId: string | null;
  public extraPrice: number = 0;
}

export class MenuGroup {
  public id: string;
  public title: string;
  public items: MenuItem[];
}
